import { render, staticRenderFns } from "./Uheader.vue?vue&type=template&id=6a0aa0a6&scoped=true"
import script from "./Uheader.vue?vue&type=script&lang=js"
export * from "./Uheader.vue?vue&type=script&lang=js"
import style0 from "./Uheader.vue?vue&type=style&index=0&id=6a0aa0a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0aa0a6",
  null
  
)

export default component.exports